<template>
  <div>
    <!--<div class="card-img-top"> </div>-->
    <div class="card-body">
      <h5 class="card-title text-blue display-4">
        <font-awesome-icon :icon="icon"></font-awesome-icon>
        {{title}}
      </h5>
      <base-alert v-if="text" class="base-alert" type="primary">
        <font-awesome-icon  class="mr-1" :icon="{ prefix: 'fas', iconName: 'info-circle' }"/>
        {{text}}
      </base-alert>
    </div>
  </div>

</template>
<script>

export default {
  name: 'cardHeader',
  props: ['title', 'icon', 'text']
}
</script>
<style lang="sass">
  .card-img-top
    @media screen and (max-width: 600px)
      height: 100px
    @media screen and (min-width: 600px)
      height: 100px
    height: 200px

    .card-img-overlay
      color: white

    .description-text
      font-weight: 400
  .base-alert
    background-color: #cce5ff
    border-color: #b8daff
    color: #004085

</style>
